<template>
    <div class="projects__container">

        <div class="current__project">

            <template v-if="current_project">
            
                <div class="info">
                   
                    <div class="logo__container">
                        <!-- <img class="logo" :src="get_project_logo()" alt="Project logo"> -->
                        <div class="logo" v-bind:style="get_project_logo()"></div>
                    </div>


                    <a class="moredetails_btn" :href="'/projects/' + this.current_project.slug">
                        <p>MORE DETAILS</p>
                        <div class="span_bg"></div>
                    </a>


                    <div class="arrows">
                        <img class="left" alt="previous project" src="/images/icons/left.webp" @mouseover="stopAutoPlay()" @click="changeProject(-1)">
                        <img class="right projectautoplayflag" alt="next project" src="/images/icons/right.webp" @mouseover="stopAutoPlay()" @click="changeProject(1)">
                    </div>

                </div>
                <div class="video" id="project-video">
                    <div class="video__container">
                        <video muted id="project_video_player" playsinline="true" preload="metadata">
                            <source :src="this.current_project_video" type="video/mp4">
                            Your browser does not support HTML video.
                        </video>
                        <template v-if="video_is_playing">
                            <div class="pause__icon projectautoplayflag" @mouseover="stopAutoPlay()" @click="pauseVideo()"></div>
                        </template>
                        <template v-else>
                            <div class="play__icon projectautoplayflag" @mouseover="stopAutoPlay()" @click="playProjectVideo()"></div>
                        </template>
                        <div class="overlay">
                            <project-overlay :overlay_type="this.current_project.overlay_type"></project-overlay>
                        </div>
                        <div class="placeholder" id="project_video_placeholder" :style="this.current_project.video_placeholder"></div>
                    </div>
                    
                </div>

                <template v-if="!video_is_playing">
                    <div class="project__information">

                        <div class="items">
                            <p class="subline">
                                {{ this.current_project.subline }}
                            </p>
                            <p class="title">
                                {{ this.current_project.name }}
                            </p>
                            <p class="short_desc">
                                {{ this.current_project.short_description }}
                            </p>
                        </div>
                       
                    </div>
                </template>
                

                <div class="mobile-projects-view">

                    <div class="intro">
                        <p class="red">OUR</p>
                        <p class="white">PROJECTS</p>
                    </div>

                    <div class="mobile__logo__container">
                        <!-- <img class="logo" :src="get_project_logo()" alt="project logo"> -->
                        <div class="logo" v-bind:style="get_project_logo()"></div>
                    </div>

                    <p class="subline">
                        {{ this.current_project.subline }}
                    </p>
                    <p class="title">
                        {{ this.current_project.title }}
                    </p>

                    <a class="more_details" :href="'/projects/' + this.current_project.slug">
                        <p>MORE DETAILS</p>
                    </a>

                    <div class="video__placeholder" :style="this.current_project.video_placeholder">
                        <template v-if="mobile_video_playing">
                            <video id="project_video_mobile_player" muted controls playsinline height="237">
                                <source :src="this.current_project_video" type="video/mp4">
                                Your browser does not support HTML video.
                            </video>
                        </template>
                        <template v-else>
                            <img src="/images/icons/play.webp" alt="play mobile" @click="playMobileVideo()">
                        </template>

                    </div>

                    <div class="mobile__navigation">
                        <div class="next" @click="changeProject(-1, true)">
                            <img src="/images/icons/left.webp" alt="previous project">
                            <p class="text">PREVIOUS PROJECT</p>
                        </div>
                        <div class="prev" @click="changeProject(1, true)">
                            <p class="text">NEXT PROJECT</p>
                            <img src="/images/icons/right.webp" alt="next project">
                        </div>
                    </div>

                </div>

            </template>

        </div>

    </div>
</template>
<script>
    import ProjectOverlay from '../components/Overlay.vue';
    export default {
        data(){
            return {
                current_project: null,
                current_project_video: null,
                current_project_gradient: null,
                current_project_image: null,
                current_mobile_project_gradient: null,
                slider_index: 0,
                video_is_playing: false,
                bg_prime_color: null,
                autoplay_on: true,
                videoAutoplayTimeout: null,
                projectAutoplayTimeout: null,

                video_autoplay_timer: 5000,
                project_autoplay_timer: 15000,

                mobile_video_playing: false,
            }
        },
        props: ['projects'],
        created(){
            window.addEventListener('mousemove', this.trackMouseMovement);
        },
        mounted(){
            this.setCurrentProject(0);
        },
        methods: {

            get_project_logo(){
                // return '/image/' + this.current_project.media_path + '/' + this.current_project.logo;
                return {
                    backgroundImage: "url('" + '/image/' + this.current_project.media_path + '/' + this.current_project.logo + "')",
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'contain'
                };
            },

            changeProject(direction, autoplay_command = false){

                if(direction === -1){
                    if(this.slider_index === 0){
                        this.setCurrentProject(this.projects.length -1);
                    } else {
                        this.setCurrentProject(this.slider_index - 1);
                    }
                    
                } else {
                    if(this.slider_index == this.projects.length - 1){
                        this.setCurrentProject(0);
                    } else {
                        this.setCurrentProject(this.slider_index + 1);
                    }
                }

                if(this.autoplay_on && autoplay_command){
                    // this.clearAutoPlayTimeouts();
                    // this.autoplay_on = false;
                    // console.log('next project with autoplay');

                } else {
                    // console.log('next project no autoplay');
                    this.clearAutoPlayTimeouts();
                }
            },

            setCurrentProject(index){
                if(this.video_is_playing) this.pauseVideo();
                
                this.slider_index = index;
                this.current_project = this.projects[index];
                this.current_project_image =  "url('" + '/image/' + this.current_project.media_path + '/' + this.current_project.featured_image + "')";

                var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

                if(isSafari){
                    this.current_project_gradient = 'linear-gradient(230deg, #000000 10%, #000000 65%, ' + this.current_project.color + ' 92.4%)';
                } else {
                    this.current_project_gradient = 'radial-gradient(ellipse farthest-corner at 100% -35%, #000000 69%, ' + this.current_project.color +' 125%, #A4510D 72%)';
                }

                this.current_mobile_project_gradient = 'linear-gradient(180deg, #000000 10%, ' + this.current_project.color + ' 92.4%)';
                this.current_project_video = window.location.protocol + "//" + window.location.host + "/getvideo/" + this.current_project.video;
                if(this.mobile_video_playing) this.mobile_video_playing = false;

                // autoplay of video and next project switch
                if(this.autoplay_on){
                    this.setAutoPlayTimeouts();
                } else {
                    this.clearAutoPlayTimeouts();
                }
                
            },

            playProjectVideo(){
                const video = document.getElementById('project_video_player');
                const overlay = document.getElementById('project_video_placeholder');

                if(!this.video_is_playing){

                    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

                    if(isSafari){
                        video.load();
                        fetch(this.current_project_video)
                        .then(response => response.blob())
                        .then(blob => {
                            video.srcObject = blob;
                            return video.play();
                        })
                        .then(_ => {
                            // Video playback started ;)
                        })
                        .catch(e => {
                            // Video playback failed ;(
                        })
                    } else {
                        video.load();
                        video.play();
                    }

                    

                    

                    overlay.classList.add('invisible');
                    this.video_is_playing = true;
                }
            },

            pauseVideo(){
                const video = document.getElementById('project_video_player');
                const overlay = document.getElementById('project_video_placeholder');

                if(this.video_is_playing){
                    video.pause();
                    overlay.classList.remove('invisible');
                    this.video_is_playing = false;

                    // if(this.autoplay_on){
                    //     this.clearAutoPlayTimeouts();
                    //     this.autoplay_on = false;
                    // }
                }
            },

            setAutoPlayTimeouts(){
                // console.log('set timeouts');
                this.videoAutoplayTimeout = setTimeout(() => {
                    if(!this.video_is_playing){
                        this.playProjectVideo();
                    }
                }, this.video_autoplay_timer);

                this.projectAutoplayTimeout = setTimeout(() => {
                    this.changeProject(1, true);
                }, this.project_autoplay_timer);

            },

            clearAutoPlayTimeouts(){
                // console.log('clear timeouts');
                // clearTimeout();
                clearTimeout(this.videoAutoplayTimeout);
                this.videoAutoplayTimeout = null;

                clearTimeout(this.projectAutoplayTimeout);
                this.projectAutoplayTimeout = null;
            },

            stopAutoPlay(){
                if(this.autoplay_on){
                    this.autoplay_on = false;
                    this.clearAutoPlayTimeouts();
                }
            },


            playMobileVideo(){

                if(!this.mobile_video_playing){
                    this.mobile_video_playing = true;

                    setTimeout(() => {

                        const video = document.getElementById('project_video_mobile_player');

                        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

                        this.stopAutoPlay();

                        if(video){
                            
                            if(isSafari){
                                // video.load();
                                video.autoplay = true;

                                fetch(this.current_project_video)
                                .then(response => response.blob())
                                .then(blob => {
                                    video.srcObject = blob;
                                    return video.play();
                                })
                                .then(_ => {
                                    // Video playback started ;)
                                })
                                .catch(e => {
                                    // Video playback failed ;(
                                })
                            } else {
                                video.load();
                                video.play();
                            }
                        }

                    }, 50)

                    

                   
                    
                    // overlay.classList.add('invisible');
                }

                // project_video_mobile_player
            }
        }
    }
</script>
<style lang="scss" scoped>
    .projects__container{
        height: 100%;
        width: 100%;

        .current__project{
            display: flex;
            flex-direction: row;
            position: relative;
            height: 100%;

            .info{
                // background: black;
                // background: linear-gradient(227.28deg, #000000 54.74%, #A4510D 91.21%);

                background: v-bind(current_project_gradient);

                -webkit-transition: background-color 1000ms linear;
                -ms-transition: background-color 1000ms linear;
                transition: background-color 1000ms linear;

                // min-width: 523px;
                // width: 523px;
                min-width: 471px; // 523 - padding(52)
                width: 471px; 
                height: 100%;

                display: flex;
                flex-direction: column;
                // justify-content: flex-start;
                justify-content: center;

                padding-left: 52px;
                position: absolute;
                z-index: 2;
            

                .logo__container{
                    // display: block;
                    display: inline-grid;
                    width: 292px;
                    height: 262px;
                    margin-left: auto;
                    margin-right: auto;

                    // img.logo{
                    //     display: block;
                    //     width: 100%;
                    //     height: auto;
                    //     margin-top: auto;
                    //     margin-bottom: 0;
                    // }

                    .logo{
                        display: block;
                        width: 100%;
                        // height: auto;
                        height: 262px;
                        margin-top: auto;
                        margin-bottom: 0;

                        transition: all 0.3s ease;
                        opacity: 1;
                    }
                }

                

                a.moredetails_btn{
                    background: rgba(0, 0, 0, 0.6);
                    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
                    width: 246px;
                    height: 45px;
                    margin-bottom: -9px;
                    cursor: pointer;
                    user-select: none;
                    position: relative;
                    overflow-y: hidden;
                    z-index: 4;
                    margin-top: 50px;
                    margin-left: auto;
                    margin-right: auto;
                    text-decoration: none;
                    border: 1px solid #ED1163;

                    p{
                        font-family: "DIN Next LT Pro Medium", Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-size: 18px;
                        line-height: 50px;
                        text-align: center;
                        text-transform: uppercase;
                        margin: 0 auto;

                        color: #FFFFFF;
                        position: relative;
                        z-index: 4;
                    }

                    div.span_bg{
                        background: linear-gradient(90deg, #ED1163 0%, #5C2C90 96.27%);
                        height: 100%;
                        width: 100%;
                        transition: all .3s ease-in-out;
                        margin-top: auto;
                        margin-bottom: 0;
                        opacity: 0;

                        position: absolute;
                        bottom: -50px;
                        z-index: 3;
                    }

                    &:hover{
                        div.span_bg{
                            height: calc(100%);
                            bottom: 0;
                            opacity: 1;
                        }
                    }
                }

                .arrows{
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    margin-top: 60px;

                    img{
                        display: block;
                        width: 24px;
                        height: 24px;
                        cursor: pointer;
                        transition: all .3s ease-in-out;

                        &:hover{
                            transform: scale(1.1);
                            filter: brightness(0) invert(1);
                        }

                        padding: 6px;
                        border: 1px solid #ED1163;
                    }

                    img.left{
                        margin-right: 70px;
                    }

                    img.right{
                        margin-left: 70px;
                    }
                }
            }

            .video{
                display: block;
                position: relative;
                width: 100%;
                // height: 100%;
                // height: 100vh;
                height: calc(100vh - 92px);


                .video__container{
                    position: absolute;
                    top: 0;
                    // left: 575px;
                    // left: 471px; // 523 - padding(52)
                    left: 523px;
                    bottom: 0;
                    width: 100%;
                    // height: 100%;
                    height: 100vh;
                    overflow: hidden;

                    &:hover{
                        .play__icon, .pause__icon{
                            right: 50%;
                        }
                    }

                    .play__icon, .pause__icon{
                        cursor: pointer;
                        display: block;
                        position: absolute;
                        width: 45px;
                        height: 45px;
                        top: 50%;
                        // right: 35%;
                        right: 0;
                        transform: translate(-50%,-50%);
                        z-index: 10;


                        transition: all .3s ease;
                    }

                    .play__icon{
                        background:url('/images/icons/play.webp') no-repeat 0 0;
                        background-size: cover;
                        transition: all .3s ease;

                        &:hover{
                            background:url('/images/icons/play_hover.webp') no-repeat 0 0;
                            background-size: cover;
                            transition: all .3s ease;
                        }
                    }

                    .pause__icon{
                        background:url('/images/icons/pause.webp') no-repeat 0 0;
                        background-size: cover;
                        transition: all .3s ease;

                        &:hover{
                            background:url('/images/icons/pause_hover.webp') no-repeat 0 0;
                            background-size: cover;
                            transition: all .3s ease;
                        }
                    }

                    video{
                         /* Make video to at least 100% wide and tall */
                        min-width: 100%; 
                        min-height: 100%; 
                        
                        /* Setting width & height to auto prevents the browser from stretching or squishing the video */
                        width: auto;
                        height: auto;
                        
                        /* Center the video */
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%,-50%);
                        z-index: 3;
                    }

                    .placeholder{
                        display: block;
                        position: relative;
                        width: 100%;
                        height: 100%;

                        // background: url('/placeholders/projects/gothic.webp');
                        background: v-bind(current_project_image);
                        background-position: center;
                        background-size: cover;
                        background-repeat: no-repeat;
                        // background-color: white;

                        z-index: 3;

                        transition: all .3s ease;

                        opacity: 1;

                        &.fading{

                        }

                        &.invisible{
                            opacity: 0;
                        }
                    }

                    .overlay{
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        top: 0;
                        left: 0;
                        z-index: 4;
                    }
                }

                
            }

            .project__information{
                position: absolute;
                bottom: 0;
                right: 0;
                z-index: 4;
                width: 100%;
                // max-width: 65vw;
                max-width: 60vw;

                background: rgb(0,0,0);
                background: -moz-linear-gradient(270deg, rgba(0,0,0,0.5) 25%, rgba(164,81,13,0) 75%);
                background: -webkit-linear-gradient(270deg, rgba(0,0,0,0.5) 25%, rgba(164,81,13,0) 75%);
                background: linear-gradient(270deg, rgba(0,0,0,0.5) 25%, rgba(164,81,13,0) 75%);
                filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#000000",endColorstr="#a4510d",GradientType=1);


                .items{
                    display: flex;
                    flex-direction: column;
                    max-width: 800px;
                    margin-left: auto;
                    margin-right: 0;

                    p.subline{
                        font-family: 'DIN Next LT Pro Medium', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 400;
                        font-size: 20px;
                        line-height: 24px;
                        /* identical to box height */

                        // margin-top: 124px;

                        margin-bottom: 10px;

                        align-items: center;

                        color: #ED1163;
                    }

                    p.title{
                        font-family: 'DIN Next LT Pro Medium', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 400;
                        font-weight: 700;
                        font-size: 50px;
                        line-height: 50px;

                        margin-top: 0;
                        // margin-bottom: 40px;
                        margin-bottom: 0;
                        height: 90px;

                        color: white;
                    }

                    p.short_desc{
                        font-family: 'DIN Next LT Pro UltraLight', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        font-weight: 300;
                        font-size: 16px;
                        line-height: 100%;

                        color: white;

                        // margin-bottom: 52px;

                        // margin-bottom: 78px;
                        margin-bottom: 0;
                        height: 94px;
                    }
                }

            }

            .mobile-projects-view{
                display: none;
                flex-direction: column;

                .intro{
                    display: flex;
                    flex-direction: column;
                    width: calc(100% - 22px);
                    margin-top: 5px;
                    margin-bottom: 10px;
                    margin-left: auto;
                    margin-right: auto;

                    border-bottom: 1px solid #ED1163;


                    .red{
                        font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 14px;
                        line-height: 17px;
                        /* identical to box height */

                        color: #ED1163;
                        margin: 0;
                        margin-left: 0;
                        margin-right: 11px;
                        text-align: end;
                    }

                    .white{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 16px;
                        line-height: 19px;
                        text-align: end;

                        color: #FFFFFF;
                        margin: 0;
                        margin-left: 0;
                        margin-right: 11px;
                    }
                }

                .mobile__logo__container{
                    display: block;
                    width: 200px;
                    height: 200px;
                    margin-left: auto;
                    margin-right: auto;
                    margin-top: 35px;

                    // img.logo{
                    //     display: block;
                    //     width: 100%;
                    //     height: auto;
                    //     margin-top: auto;
                    //     margin-bottom: 0;
                    //     max-width: 200px;

                    //     margin-left: auto;
                    //     margin-right: auto;

                    //     margin-top: 50%;
                    //     transform: translateY(-50%);
                    // }             
                    .logo{
                        display: block;
                        width: 100%;
                        // height: auto;
                        height: 200px;
                        margin-top: auto;
                        margin-bottom: 0;
                        max-width: 200px;

                        margin-left: auto;
                        margin-right: auto;

                        margin-top: 50%;
                        transform: translateY(-50%);
                    }                    
                }

                .subline{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    font-weight: 700;
                    font-size: 12px;
                    line-height: 14px;
                    text-align: center;
                    margin: 0;

                    color: #ED1163;
                    margin-top: 35px;
                }

                .title{
                    font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    // font-weight: 700;
                    font-size: 20px;
                    line-height: 24px;
                    /* identical to box height */
                    margin: 0;
                    text-align: center;

                    color: #FFFFFF;
                }

                .more_details{
                    background: rgba(0, 0, 0, 0.6);
                    border: 1px solid #ED1163;
                    width: calc(100% - 22px);
                    margin-left: auto;
                    margin-right: auto;
                    height: 31px;
                    margin-top: 30px;
                    margin-bottom: 10px;
                    text-decoration: none;
                    
                    p{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 12px;
                        line-height: 33px;
                        text-align: center;

                        margin: 0;

                        color: #FFFFFF;
                    }
                }

                .video__placeholder{
                    width: 100%;
                    height: 237px;

                    background-size: cover;
                    background-position: center;
                    background: v-bind(current_project_image) center;
                }
            }
            
        }
    }

    @media screen and (max-width: 836px) {

        .projects__container{
            background: #000;

            .current__project{
                flex-direction: column;
                background: v-bind(current_mobile_project_gradient);

                -webkit-transition: background-color 1000ms linear;
                -ms-transition: background-color 1000ms linear;
                transition: background-color 1000ms linear;

                .info, .video{
                    display: none;
                }

                .project__information{
                    display: none;
                }

                .mobile-projects-view{
                    display: flex;

                    .video__placeholder{
                        position: relative;

                        img{
                            position: absolute;
                            top: 50%; right: 50%;
                            transform: translate(50%,-50%);
                            display: block;
                            width: 32px;
                            height: 32px;
                        }

                        video{
                            // height: auto;
                            width: 100%;
                        }


                    }

                    .mobile__navigation{
                        display: flex;
                        flex-direction: row;
                        // margin-top: 27px;
                        background: #000000;

                        .next, .prev{
                            height: 56px;
                            width: 100%;
                            display: flex;
                            flex-direction: row;
                            justify-content: center;

                            // border-bottom: 1px solid #ED1163;

                            img{
                                display: block;
                                width: 24px;
                                height: 24px;
                                margin-top: auto;
                                margin-bottom: auto;
                            }

                            .text{
                                font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                                font-style: normal;
                                font-weight: 400;
                                font-size: 12px;
                                line-height: 14px;

                                text-transform: uppercase;

                                color: #ED1163;
                                margin: 0;
                                // margin-top: auto;
                                margin-top: 23px;
                                margin-bottom: auto;
                            }
                        }

                        .next{
                            border-right: 1px solid #ED1163;
                            
                            img{
                                margin-right: 8px;
                            }
                        }

                        .prev{
                            border-left: 1px solid #ED1163;

                            img{
                                margin-left: 8px;
                            }
                        }
                    }
                }
            }

            
        }

    }

    @media screen and (min-width: 836px) and (max-height: 900px) {

        .projects__container{

            .current__project{

                .info{

                    p.short_desc{
                        margin-bottom: 0;
                    }

                }

            }

        }

    }
</style>